import {connect} from 'react-redux';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as ModalActions from '../../../actions/ModalActions';
import {withRouter} from 'react-router';
import FileFailedUploadErrorView from '../../../components/views/mx/creditoReal/FileFailedUploadErrorView';

const mapDispatchToProps = (dispatch) => {
    return {
        onPressNext: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
    };
};

const FileFailedUploadErrorContainer = withRouter<any, any>(connect(
    null,
    mapDispatchToProps,
    mergeProps
)(FileFailedUploadErrorView));

export default FileFailedUploadErrorContainer;
